<template>
    <div>
        <Combobox
                :modelValue="modelValue"
                @update:modelValue="value => emit('update:modelValue', value)"
                :multiple="allowMultiple"
                as="div">
            <div class="relative mt-1">
                <ComboboxInput
                        class="w-full py-2 pl-3 pr-10 bg-white border border-clay-500 rounded-md shadow-sm focus:border-electric-500 focus:outline-hidden focus:ring-1 focus:ring-electric-500 sm:text-sm"
                        :displayValue="allowMultiple ? (territories: Array<Region>) => territories.map((t: Region) => t.name) : (t) => t.name"
                        @change="territoryQuery = $event.target.value"/>
                <ComboboxButton
                        class="absolute inset-y-0 right-0 flex items-center px-2 rounded-r-md focus:outline-hidden">
                    <SelectorIcon aria-hidden="true" class="w-5 h-5 text-gray-400"/>
                </ComboboxButton>

                <ComboboxOptions
                        class="absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-hidden sm:text-sm">
                    <ComboboxOption v-for="territory in filteredTerritories"
                                    :key="territory.id"
                                    v-slot="{ active, selected }"
                                    :value="territory" as="template">
                        <li :class="['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-electric-600 text-white' : 'text-gray-900']">
                            <span :class="['block truncate', selected && 'font-semibold']">
                                {{ territory.name }}
                            </span>
                            <span v-if="selected"
                                  :class="['absolute inset-y-0 flex items-center pl-1.5', active ? 'text-white' : 'text-electric-600']">
                                <CheckIcon aria-hidden="true" class="w-5 h-5"/>
                            </span>
                        </li>
                    </ComboboxOption>
                </ComboboxOptions>
            </div>
        </Combobox>
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineEmits, defineProps, ref} from "vue";
import {
    Region,
} from "@/dtos";

import {Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions} from '@headlessui/vue';
import {CheckIcon} from '@heroicons/vue/20/solid';

const props = defineProps({
    territories: {
        type: Array,
        default: []
    },
    allowMultiple:{
        type: Boolean,
        default: false
    },
    modelValue: {
        type: Object,
        default: {}
    }
})

const emit = defineEmits(['update:modelValue'])

const territoryQuery = ref('');

const filteredTerritories = computed(() =>
    territoryQuery.value === ''
        ? props.territories
        : props.territories.filter((territory: Region) => {
                return territory.name.toLowerCase().includes(territoryQuery.value.toLowerCase())
            }
        )
)

</script>
<style>

</style>